<script>
import {
    mapGetters
} from 'vuex';
export default {
    name: 'StepByStepGuideDataProvider',
    props: {
        initialStepId: {
            type: String,
            default: ''
        },
        stepIds: {
            type: Array,
            default: () => []
        },
        apiUrl: {
            type: String,
            default: 'api/GuideSteps/'
        }
    },
    computed: mapGetters('stepByStepGuide', {
        loading: 'loading',
        guideSteps: 'guideSteps',
    }),
	data() {
		return {
			headingText: ''
		}
	},
    methods: {
        fetchStep({
            appendAfter,
            stepId,
			stepText
        }) {
			// Google Analytics
			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({
				'event': 'guideEvent',
				'eventCategory': 'Guider',
				'eventAction': this.headingText,
				'eventLabel': stepText
			});
			//

            this.$store.dispatch('stepByStepGuide/addToSequence', {
                appendAfter: appendAfter,
                stepId: stepId
            }).then(() => {
                let stepIdString = this.guideSteps.reduce((acc, step) => {
                    if (acc) {
                        return acc + ',' + step.id;
                    } else {
                        return step.id;
                    }
                }, '');
                history.pushState({}, null, window.location.origin + window.location.pathname + '#/' + stepIdString);
                this.$nextTick(() => document.querySelector('#step-' + stepId).scrollIntoView({
                    behavior: 'smooth'
                }));
            });
        }
    },
    render() {
        if (!this.$scopedSlots.default) {
            return;
        }

        const slotScope = {
            loading: this.loading,
            guideSteps: this.guideSteps,
            fetchStep: this.fetchStep,
        };

        return this.$scopedSlots.default(slotScope);
    },
    created() {
		let heading = document.querySelector('h1.c-intro__heading');
		if (heading) this.headingText = heading.innerText;

        let addToSequence = [];
        if (this.initialStepId && this.stepIds.length === 0) {
            addToSequence.push(this.initialStepId);
        } else if (this.stepIds.length > 0) {
            addToSequence = this.stepIds;
        }

        this.$store.dispatch('stepByStepGuide/fetchGuideSteps', {
            apiUrl: this.apiUrl,
            addToSequence: addToSequence
        });
    }
}
</script>
